<template>
  <b-col
    cols="3"
    class="mt-3"
  >
    <b-card
      class="mb-0"
      header-class="border-0"
    >
      <b-container>
        <b-row no-gutters>
          <b-col class="text-muted">
            {{ title }}
          </b-col>
          <base-help-tooltip
            popover-placement="bottom"
            v-if="tooltipText"
          >
            <template v-slot:popover-body>
              <p>{{ tooltipText }}</p>
            </template>
          </base-help-tooltip>
        </b-row>
      </b-container>
      <b-card-body class="p-2">
        <div
          class="h1"
          :data-test="dataTest"
        >
          <slot name="custom-value">
            {{ value }}
          </slot>
        </div>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>

import BaseHelpTooltip from '@/components/BaseHelpTooltip.vue';

export default {
  name: 'OverviewStat',
  components: {
    BaseHelpTooltip,
  },
  props: {
    dataTest: {
      type: String,
      required: false,
      default: 'stat',
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    tooltipText: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
